import { computed, type Ref } from 'vue'
import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

export const useLoadTypePassportGridField = (
  objectTypeId: number,
  objectId: string,
  open: Ref<boolean>,
) => {
  const http = useHttp()

  const queryKey = computed(() => ['load_type_passport_grid_field', objectTypeId])

  const url = computed(() => `/inventory/group/${objectId}/type-field/${objectTypeId}`)

  return useQuery({
    queryKey: queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: () => open.value,
  })
}
